export default __webpack_public_path__ + "static/media/mountain_church_768.87bb5146.webp";